import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import TreeMarkingName from "../../components/treeMarking/TreeMarkingDetail/TreeMarkingName.tsx";
import {useLocationFormState} from "../../components/treeMarking/TreeMarkingForm/TreeMarkingUpdateForm";
import TreeMarkingUpdateFormProvider from "../../components/treeMarking/TreeMarkingForm/TreeMarkingUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const TreeMarkingUpdateEditPage = () => {
    
    useTitle(t`Update Tree Marking`);

    const { treeMarkingId: id } = useParams();
    
    return (
        <Box data-testid="TreeMarking-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="TreeMarking-update-title"
                    >
                        <Trans>Edit Tree Marking</Trans>:  <TreeMarkingName id={id}/>
                    </Typography>
                    <TreeMarkingUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default TreeMarkingUpdateEditPage;
